import client, { ApiVersion } from '@web/api/client'
import Logger from '@web/common/Logger'
import { MODAL_ACTIONS_HEADER } from './constants'
import { toModalRules } from './mapper'
import type { ModalRule } from './types'

// X-Mobile-App-Id не шлём: его отсутствие и означает «веб» — сервер отдаёт только web_*.
export async function fetchModalRules (): Promise<ModalRule[]> {
  try {
    const { data } = await client.get('/modal', {
      apiVersion: ApiVersion.v2,
      headers: { 'X-Modal-Actions': MODAL_ACTIONS_HEADER }
    })
    return toModalRules(data)
  } catch (e) {
    Logger.warn('[modal-builder] не удалось получить правила', e)
    return []
  }
}
